module.exports = __webpack_public_path__ + "assets/language-squares/fr@2x-fe939b09c901447363631e16417b89cf.jpg";